import { RecaptchaVerifier, signInWithPhoneNumber, signOut } from "firebase/auth";
import { auth } from "../utils/firebase";

class PhoneAuthService {
  static recaptchaVerifier = null;

  static initRecaptcha() {
    if (this.recaptchaVerifier) return;

    console.log("⚙️ Инициализация reCAPTCHA verifier...");

    try {
      // ✅ Новый порядок аргументов
      this.recaptchaVerifier = new RecaptchaVerifier(
        auth, // сначала auth!
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => {
            console.log("✅ reCAPTCHA успешно пройдена:", response);
          },
          "expired-callback": () => {
            console.warn("⚠️ reCAPTCHA истекла");
          },
        }
      );

      this.recaptchaVerifier.render().then((widgetId) => {
        console.log("🔵 reCAPTCHA widget ID:", widgetId);
      });
    } catch (error) {
      console.error("❌ Ошибка при инициализации reCAPTCHA:", error);
      throw error;
    }
  }

  static async sendCode(phoneNumber) {
    try {
      if (!this.recaptchaVerifier) this.initRecaptcha();

      console.log("📲 Отправляем SMS на:", phoneNumber);
      const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, this.recaptchaVerifier);
      console.log("📩 SMS успешно отправлено");
      return confirmationResult;
    } catch (error) {
      console.error("🔥 Ошибка при отправке кода:", error.code, error.message, error);
      throw error;
    }
  }

  static async verifyCode(confirmationResult, code) {
    try {
      const result = await confirmationResult.confirm(code);
      console.log("✅ Код подтверждён:", result.user);
      return result.user;
    } catch (error) {
      console.error("❌ Ошибка при проверке кода:", error.code, error.message);
      throw error;
    }
  }

  static async logout() {
    try {
      await signOut(auth);
      console.log("✅ Выход выполнен");
    } catch (error) {
      console.error("❌ Ошибка выхода:", error.code, error.message);
    }
  }
}

export default PhoneAuthService;